import { FC } from 'react'

import { Stack } from '@mui/material'
import { PickerValue } from '@mui/x-date-pickers/internals'

import { DateSelect } from './DateSelect/DateSelect'

export const FROM_DATE_LABEL = 'From date'
export const TO_DATE_LABEL = 'To date'

export type Period = {
  fromDate: Date | null
  toDate: Date | null
}

type Props = {
  period: Period
  onChange: (period: Period) => void
}

export const PeriodSelect: FC<Props> = ({ period, onChange }) => {
  const { fromDate, toDate } = period

  const handleOnChange = (date: PickerValue, type: 'from' | 'to') => {
    const newPeriod: Period = {
      ...period
    }

    if (!date) {
      return
    }

    if (type === 'from') {
      date.setHours(0, 0, 0, 0)
      newPeriod.fromDate = date
    }

    if (type === 'to') {
      date.setHours(23, 59, 59, 999)
      newPeriod.toDate = date
    }

    onChange(newPeriod)
  }

  return (
    <Stack direction="row" gap={1.3}>
      <DateSelect
        sx={{
          flex: 1
        }}
        label={FROM_DATE_LABEL}
        value={fromDate || null}
        onChange={(date) => {
          handleOnChange(date, 'from')
        }}
        maxDate={toDate || undefined}
      />
      <DateSelect
        minDate={fromDate || undefined}
        sx={{
          flex: 1
        }}
        label={TO_DATE_LABEL}
        value={toDate || null}
        onChange={(date) => {
          handleOnChange(date, 'to')
        }}
        maxDate={toDate || undefined}
      />
    </Stack>
  )
}
